var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-mobile"},[_c('div',{staticClass:"column"},[_vm._v(_vm._s(_vm.computedTitle)+":")]),_c('div',{staticClass:"column"},[(_vm.model[_vm.modelKey])?_c('span',[_vm._v(" "+_vm._s(_vm.computedChain)+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }